import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useResourceTypes } from '../../hooks/calculator/useResourceTypes.js';
import { useExtensionUnits } from '../../hooks/calculator/useExtensionUnits.js';
import { useMultimediaLevels } from '../../hooks/calculator/useMultimediaLevels.js';
import { useInstructionalLevels } from '../../hooks/calculator/useInstructionalLevels.js';
import { useCalculator } from '../../hooks/calculator/useCalculator.js';
import InfoModal from '../../components/modales/InfoModal.jsx';
import ErrorModal from '../../components/modales/ErrorModal.jsx';
import DescriptionModal from '../../components/modales/DescriptionModal.jsx';
import ROUTES from '../../routes/Routes.js';
import { HashLink as Ancla } from 'react-router-hash-link';

export default function Calculator() {
    // Traer los recursos por categoria
    const {
        resourceTypes: courseResourceTypes,
        loading: loadingCourses
    } = useResourceTypes('autoria');
    const {
        resourceTypes: videoResourceTypes,
        loading: loadingVideos
    } = useResourceTypes('video');

    // Traer las demas listas
    const { extensionUnits } = useExtensionUnits();
    const { multimediaLevels } = useMultimediaLevels();
    const { instructionalLevels } = useInstructionalLevels();

    // calculadoras por categoria
    const courseCalc = useCalculator();
    const videoCalc = useCalculator();

    const totalGeneral = (courseCalc.result?.totalCost || 0) + (videoCalc.result?.totalCost || 0);

    // Mostrar la descripcion
    const [modalData, setModalData] = useState({ show: false, title: '', description: '' });
    const openDescriptionModal = (title, description) => {
        setModalData({
            show: true,
            title,
            description
        });
    };
    const closeModal = () => { setModalData(prev => ({ ...prev, show: false })); };
    const getById = (list, value, key = 'id') => list.find(item => String(item[key]) === String(value));
    const selectedCourseExtensionUnit = getById(extensionUnits, courseCalc.form.extensionUnitCode, 'code');
    const selectedCourseMultimediaLevel = getById(multimediaLevels, courseCalc.form.multimediaLevelId);
    const selectedCourseInstructionalLevel = getById(instructionalLevels, courseCalc.form.instructionalLevelId);
    const selectedActivitiesCount = { name: "Actividades a medida", description: "Indicar cantidad de actividades diseñadas a medida se gusta agregar para variar la interacción en cursos de Rise." };
    const selectedVideoExtensionUnit = getById(extensionUnits, videoCalc.form.extensionUnitCode, 'code');
    //const selectedVideoMultimediaLevel = getById(multimediaLevels, videoCalc.form.multimediaLevelId);
    //const selectedVideoInstructionalLevel = getById(instructionalLevels, videoCalc.form.instructionalLevelId);

    return (
        <>
            <div className="container-fluid mt-6">
                <h1 className="text-center mb-4 fs-3">Cotiza tu proyecto</h1>
                <div className="row">
                    <div className="col-md-4 col-lg-4 order-md-last">
                        <h5 className="mb-3">Resumen</h5>
                        <ul className="list-group mb-3">
                            {/* SUBTOTAL CURSOS */}
                            <li className="list-group-item d-flex justify-content-between lh-sm">
                                <div>
                                    <h6 className="my-0">Subtotal cursos:</h6>
                                </div>
                                <span className="text-body-secondary">
                                    <strong>
                                        {courseCalc.result ? `$${courseCalc.result.totalCost.toLocaleString('es-MX')}` : '---'}
                                    </strong>
                                </span>
                            </li>
                            <li className="list-group-item d-flex justify-content-between lh-sm">
                                <div>
                                    <h6 className="my-0">Subtotal videos:</h6>
                                </div>
                                <span className="text-body-secondary">
                                    <strong>
                                        {videoCalc.result ? `$${videoCalc.result.totalCost.toLocaleString('es-MX')}` : '---'}
                                    </strong>
                                </span>
                            </li>
                            <li className="list-group-item d-flex justify-content-between lh-sm">
                                <div>
                                    <h6 className="my-0">Total:</h6>
                                </div>
                                <span className="text-body-secondary">
                                    <strong>
                                        {typeof totalGeneral === 'number' ? `$${totalGeneral.toLocaleString('es-MX')}` : '---'}
                                    </strong>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-8 col-lg-8">
                        <div className="row">
                            {/* FORM CURSOS */}
                            <div className="col-md-6">
                                <h5 className="mb-3">Cursos</h5>
                                <form onSubmit={(e) => { e.preventDefault(); courseCalc.submit(); }}>
                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="resourceTypeId" value={courseCalc.form.resourceTypeId} onChange={courseCalc.handleChange} disabled={loadingCourses} required >
                                            <option value="">Seleccione un tipo de recurso *</option>
                                            {courseResourceTypes.map(r => (
                                                <option key={r.id} value={r.id}>
                                                    {r.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Tipo de recurso:</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="extensionUnitCode" value={courseCalc.form.extensionUnitCode} onChange={courseCalc.handleChange} required >
                                            <option value="">Seleccione una medida de extensión *</option>
                                            {extensionUnits.map(u => (
                                                <option key={u.id} value={u.code}>
                                                    {u.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Medida de extensión:</label>
                                    </div>
                                    <button type="button" className="btn btn-link p-0 mb-3" disabled={!selectedCourseExtensionUnit} 
                                        onClick={() =>
                                            openDescriptionModal(
                                                `Medida de extención: ${selectedCourseExtensionUnit.name}`,
                                                selectedCourseExtensionUnit.description
                                            )
                                        } 
                                    >
                                    <i className="bi bi-info-circle me-1"></i>¿Qué incluye este nivel?
                                    </button>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingExtension_quantity" placeholder="Cantidad de datos según medida de extensión" name="extensionQuantity" type="number" min="0" value={courseCalc.form.extensionQuantity} onChange={courseCalc.handleChange} required />
                                        <label htmlFor="floatingExtension_quantity">Cantidad de datos según medida de extensión *</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingEstimated_duration_min" placeholder="Duración estimada (minutos)" name="estimatedDurationMin" type="number" min="0" step="5" value={courseCalc.result?.estimatedDuration ?? ''} disabled />
                                        <label htmlFor="floatingEstimated_duration_min">Duración estimada (minutos)</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="multimediaLevelId" value={courseCalc.form.multimediaLevelId} onChange={courseCalc.handleChange} required >
                                            <option value="">Seleccione un nivel *</option>
                                            {multimediaLevels.map(m => (
                                                <option key={m.id} value={m.id}>
                                                    {m.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Multimedia:</label>                                
                                    </div>
                                    <button type="button" className="btn btn-link p-0 mb-3" disabled={!selectedCourseMultimediaLevel} 
                                        onClick={() =>
                                            openDescriptionModal(
                                                `Nivel multimedia: ${selectedCourseMultimediaLevel.name}`,
                                                selectedCourseMultimediaLevel.description
                                            )
                                        } 
                                    >
                                    <i className="bi bi-info-circle me-1"></i>¿Qué incluye este nivel?
                                    </button>
                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="instructionalLevelId" value={courseCalc.form.instructionalLevelId} onChange={courseCalc.handleChange} required >
                                            <option value="">Seleccione un nivel *</option>
                                            {instructionalLevels.map(i => (
                                                <option key={i.id} value={i.id}>
                                                    {i.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Instruccional:</label>
                                    </div>
                                    <button type="button" className="btn btn-link p-0 mb-3" disabled={!selectedCourseInstructionalLevel} 
                                        onClick={() =>
                                            openDescriptionModal(
                                                `Nivel instruccional: ${selectedCourseInstructionalLevel.name}`,
                                                selectedCourseInstructionalLevel.description
                                            )
                                        } 
                                    >
                                    <i className="bi bi-info-circle me-1"></i>¿Qué incluye este nivel?
                                    </button>

                                    {/* SOLO RISE */}
                                    {courseResourceTypes.find( r => String(r.id) === String(courseCalc.form.resourceTypeId) )
                                        ?.code === 'COURSE_RISE' && (
                                            <>
                                                <div className="form-floating mb-3">
                                                    <input className="form-control" id="floatingActivity" placeholder="Actividades a medida" type="number" min="0" name="activitiesCount" value={courseCalc.form.activitiesCount} onChange={courseCalc.handleChange} />
                                                    <label htmlFor="floatingActivity">Actividades a medida</label>
                                                </div>
                                                <button type="button" className="btn btn-link p-0 mb-3" 
                                                    onClick={() =>
                                                        openDescriptionModal(
                                                           `${selectedActivitiesCount.name}`,
                                                            selectedActivitiesCount.description
                                                        )
                                                    } 
                                                >
                                                <i className="bi bi-info-circle me-1"></i>¿Qué incluye este nivel?
                                                </button>
                                            </>
                                        )
                                    }
                                    <button className="btn btn-primary w-100">  Cotizar curso </button>
                                </form>
                            </div>
                            {/* FORM VIDEOS */}
                            <div className="col-md-6">
                                <h5 className="mb-3">Videos</h5>
                                <form onSubmit={(e) => {e.preventDefault();videoCalc.submit();}}>
                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="resourceTypeId" value={videoCalc.form.resourceTypeId} onChange={videoCalc.handleChange} disabled={loadingVideos} required >
                                            <option value="">Seleccione un tipo de recurso *</option>
                                            {videoResourceTypes.map(r => (
                                                <option key={r.id} value={r.id}>
                                                    {r.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Tipo de recurso:</label>
                                    </div>

                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="extensionUnitCode" value={videoCalc.form.extensionUnitCode} onChange={videoCalc.handleChange} required >
                                            <option value="">Seleccione una medida de extensión *</option>
                                            {extensionUnits.map(u => (
                                                <option key={u.id} value={u.code}>
                                                    {u.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Medida de extensión:</label>
                                    </div>
                                    <button type="button" className="btn btn-link p-0 mb-3" disabled={!selectedVideoExtensionUnit} 
                                        onClick={() =>
                                            openDescriptionModal(
                                                `Medida de extención: ${selectedVideoExtensionUnit.name}`,
                                                selectedVideoExtensionUnit.description
                                            )
                                        } 
                                    >
                                    <i className="bi bi-info-circle me-1"></i>¿Qué incluye este nivel?
                                    </button>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingExtension_quantity2" placeholder="Cantidad de datos según medida de extensión" type="number" min="0" name="extensionQuantity" value={videoCalc.form.extensionQuantity} onChange={videoCalc.handleChange} required />
                                        <label htmlFor="floatingExtension_quantity2">Cantidad de datos según medida de extensión *</label>
                                    </div>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="floatingEstimated_duration_min2" placeholder="Duración estimada (minutos)" name="estimatedDurationMin" type="number" min="0" step="5" value={videoCalc.result?.estimatedDuration ?? ''} disabled />
                                        <label htmlFor="floatingEstimated_duration_min2">Duración estimada (minutos)</label>
                                    </div>

                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="multimediaLevelId" value={videoCalc.form.multimediaLevelId} onChange={videoCalc.handleChange} required >
                                            <option value="">Seleccione un nivel *</option>
                                            {multimediaLevels.map(m => (
                                                <option key={m.id} value={m.id}>
                                                    {m.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Multimedia:</label>
                                    </div>
                                    <Ancla to={`${ROUTES.DESCRIPTIONS}#multimedia`}  className='btn btn-link p-0 mb-3'>
                                        <i className="bi bi-info-circle me-1"></i>Ver mas información
                                    </Ancla>
                                    {/*
                                    <button type="button" className="btn btn-link p-0 mb-3" disabled={!selectedVideoMultimediaLevel} 
                                        onClick={() =>
                                            openDescriptionModal(
                                                `Nivel multimedia: ${selectedVideoMultimediaLevel.name}`,
                                                selectedVideoMultimediaLevel.description
                                            )
                                        } 
                                    >
                                    <i className="bi bi-info-circle me-1"></i>¿Qué incluye este nivel?
                                    </button>
                                    */}

                                    <div className="form-floating mb-3">
                                        <select className="form-select" name="instructionalLevelId" value={videoCalc.form.instructionalLevelId} onChange={videoCalc.handleChange} required >
                                            <option value="">Seleccione un nivel *</option>
                                            {instructionalLevels.map(i => (
                                                <option key={i.id} value={i.id}>
                                                    {i.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label>Instruccional:</label>
                                    </div>
                                    <Ancla to={`${ROUTES.DESCRIPTIONS}#instruccional`}  className='btn btn-link p-0 mb-3'>
                                        <i className="bi bi-info-circle me-1"></i>Ver mas información
                                    </Ancla>
                                    {/*
                                    <button type="button" className="btn btn-link p-0 mb-3" disabled={!selectedVideoInstructionalLevel} 
                                        onClick={() =>
                                            openDescriptionModal(
                                                `Nivel instruccional: ${selectedVideoInstructionalLevel.name}`,
                                                selectedVideoInstructionalLevel.description
                                            )
                                        } 
                                    >
                                    <i className="bi bi-info-circle me-1"></i>¿Qué incluye este nivel?
                                    </button>
                                    */}
                                    <button className="btn btn-primary w-100"> Cotizar video </button>
                                </form>
                            </div>
                        </div>
                        <div className="py-3">
                            <Link to={ROUTES.HOME} className="btn btn-secondary w-100">
                                Cancelar
                            </Link>
                        </div>
                    </div>
                </div>
                
            </div>
            {/* MODALES */}
            <InfoModal
                show={courseCalc.showInfoModal || videoCalc.showInfoModal}
                message={courseCalc.infoMessage || videoCalc.infoMessage}
                onClose={() => { courseCalc.closeInfoModal(); videoCalc.closeInfoModal(); }}
            />

            <ErrorModal
                show={courseCalc.showErrorModal || videoCalc.showErrorModal}
                message={courseCalc.errorMessage || videoCalc.errorMessage}
                onClose={() => { courseCalc.closeErrorModal(); videoCalc.closeErrorModal(); }}
            />

            <DescriptionModal
                show={modalData.show}
                title={modalData.title}
                description={modalData.description}
                onClose={closeModal}
            />
        </>
    );
}